import React from 'react';
import { useRouter } from '../context/RouterContext';

interface HeaderProps {
  onUploadClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onUploadClick }) => {
  const { currentRoute, navigate } = useRouter();
  return (
    <header className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl shadow-sm border-b border-gray-200/50 dark:border-slate-700/50 sticky top-0 z-40">
      <div className="px-3 sm:px-4 py-2 sm:py-3">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <button 
            onClick={() => navigate('home')}
            className="flex items-center gap-2 sm:gap-3 hover:opacity-90 transition-opacity group"
          >
            <img 
              src="/R8MYPL8.png" 
              alt="Rate My Plate Logo" 
              className="w-16 h-8 sm:w-20 sm:h-10 rounded-lg object-contain"
            />
            <div className="hidden sm:block">
              <h1 className="text-lg font-bold text-gray-900 dark:text-white">Rate My Plate</h1>
              <span className="text-xs text-gray-500 dark:text-slate-400">Funny &amp; Custom License Plate Ideas</span>
            </div>
          </button>
          <div className="flex items-center gap-2 sm:gap-4">
            <button
              onClick={onUploadClick}
              className="bg-primary-500 hover:bg-primary-600 dark:bg-primary-500 dark:hover:bg-primary-400 text-white px-3 py-2 sm:px-4 rounded-xl font-medium text-sm sm:text-base shadow-soft hover:shadow-glow transition-all duration-200"
            >
              Upload
            </button>
            <button 
              onClick={() => navigate('about')}
              className={`px-3 py-2 sm:px-4 rounded-xl transition-all duration-200 text-sm sm:text-base font-medium ${
                currentRoute === 'about' 
                  ? 'bg-primary-100 dark:bg-primary-500/20 text-primary-600 dark:text-primary-400' 
                  : 'text-gray-600 dark:text-slate-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-slate-800'
              }`}
            >
              About
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
